var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content content-full font-size-sm text-muted text-center"},[_c('strong',[_vm._v("2015-18 © "),_c('span',{attrs:{"data-toggle":"year-copy"}}),_vm._v(" ARA1857 S.p.A.")])])
}]

export { render, staticRenderFns }